import React, { Component } from 'react'

// lib
import classnames from 'classnames'

// ui
import Button from '../../components/uielements/button'
import { Input } from 'antd'

// icon
import { FaUpload } from 'react-icons/fa'

// redux
import { connect } from 'react-redux'
import ReportActions from '../../redux/component_select_report/actions'

const { Search } = Input

class HeadBar extends Component {
    render() {
        const { selectLength } = this.props

        return (
            <div className={classnames('row', 'HeaderBar')}>
                <div>
                    Có {selectLength} tài liệu được chọn
                </div>
                <div>
                    <Search
                        className="SearchBox"
                        placeholder="Nhập để tìm kiếm"
                        onSearch={value => this.props.searchReport()}
                        onChange={e =>
                            this.props.updateCurrentTextSearch(e.target.value)
                        }
                        value={this.props.textSearch}
                    />
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        textSearch: state.component_select_report.textSearch,
        selectLength: state.component_select_report.selectedReport.length,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        updateCurrentTextSearch: textSearch => {
            dispatch(ReportActions.action.updateTextSearch(textSearch))
        },
        searchReport: () => {
            dispatch(ReportActions.action.searchReport())
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(HeadBar)
